import {
  Check,
  Circle,
  CircleInfo,
  Xmark,
} from '@unified-checkout/design-system/icons/index';

import { FeaturedIcon } from '../FeaturedIcon';
import { ITimelineProps } from '../../types/timeline';

export const STEPS_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  PENDING: 'pending',
  DEFAULT: 'default',
  WARNING: 'warning',
} as const;

export const STEP_ICON_MAPPER = (
  props: ITimelineProps['defaultIconProps']
) => ({
  [STEPS_STATUS.SUCCESS]: (
    <FeaturedIcon icon={Check} color="green" size="xs" {...props} />
  ),
  [STEPS_STATUS.FAILED]: (
    <FeaturedIcon icon={Xmark} color="red" size="xs" {...props} />
  ),
  [STEPS_STATUS.PENDING]: (
    <FeaturedIcon icon={Circle} color="primary" size="xs" {...props} />
  ),
  [STEPS_STATUS.DEFAULT]: (
    <FeaturedIcon icon={Circle} color="gray" size="xs" {...props} />
  ),
  [STEPS_STATUS.WARNING]: (
    <FeaturedIcon icon={CircleInfo} color="yellow" size="xs" {...props} />
  ),
});
